var _path, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBfidIdVerificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 47,
    viewBox: "0 0 36 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9972 37.4675C22.4835 36.0363 33.2617 30.1571 33.7574 12.0303C33.7794 11.2264 33.3599 10.4666 32.6771 10.0417C23.642 4.41986 12.1975 4.41986 3.16247 10.0417C2.47961 10.4666 2.06015 11.2264 2.08214 12.0303C2.57784 30.1571 13.356 36.0363 16.8424 37.4675C17.5378 37.7529 18.3017 37.7529 18.9972 37.4675Z",
    fill: "url(#paint0_linear_8143_15485)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_8143_15485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0309 45.9546C22.758 44.5418 35.3477 38.3104 35.9756 18.4299C36.0059 17.4716 35.4949 16.5711 34.6708 16.0812C24.3963 9.97262 11.6037 9.97262 1.32922 16.0812C0.50508 16.5711 -0.00590926 17.4716 0.0243616 18.4299C0.652336 38.3104 13.242 44.5418 16.9691 45.9546C17.6419 46.2096 18.3581 46.2096 19.0309 45.9546Z",
    fill: "#FB6C6C",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7421 18.4225C35.4298 28.3098 32.1451 34.7858 28.4896 38.9638C24.8307 43.1457 20.7885 45.0385 18.9481 45.7362C18.3287 45.971 17.6713 45.971 17.0519 45.7362C15.2115 45.0385 11.1693 43.1457 7.51039 38.9638C3.85488 34.7858 0.570168 28.3098 0.257852 18.4225C0.230358 17.5521 0.69498 16.73 1.4486 16.282C11.6495 10.2172 24.3505 10.2172 34.5514 16.282C35.305 16.73 35.7696 17.5521 35.7421 18.4225Z",
    stroke: "url(#paint1_linear_8143_15485)",
    strokeOpacity: 0.7,
    strokeWidth: 0.467213
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8143_15485)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4188 22.0072C27.0855 22.6641 27.0855 23.729 26.4188 24.3859L18.4515 32.2351C18.1314 32.5505 17.6971 32.7277 17.2443 32.7277C16.7915 32.7277 16.3573 32.5505 16.0371 32.2351L11.4844 27.7498C10.8177 27.093 10.8177 26.028 11.4844 25.3712C12.1511 24.7143 13.2321 24.7143 13.8988 25.3712L17.2443 28.6671L24.0043 22.0072C24.6711 21.3504 25.752 21.3504 26.4188 22.0072Z",
    fill: "url(#paint2_linear_8143_15485)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2582 22.1701C26.834 22.7374 26.834 23.6557 26.2582 24.223L18.291 32.0721C18.014 32.3451 17.6376 32.499 17.2443 32.499C16.8511 32.499 16.4747 32.3451 16.1976 32.0721L11.6449 27.5869C11.0691 27.0196 11.0691 26.1013 11.6449 25.5341C12.2226 24.9649 13.1606 24.9649 13.7383 25.5341L17.0838 28.83C17.1728 28.9177 17.3158 28.9177 17.4048 28.83L24.1648 22.1701C24.7425 21.601 25.6805 21.601 26.2582 22.1701Z",
    stroke: "url(#paint3_linear_8143_15485)",
    strokeWidth: 0.457417,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_8143_15485",
    x: -12.311,
    y: -0.83467,
    width: 60.622,
    height: 59.315,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.16721
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8143_15485"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8143_15485",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8143_15485",
    x: 10.0499,
    y: 21.5146,
    width: 17.8024,
    height: 13.082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.934426
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.467213
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8143_15485"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8143_15485",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8143_15485",
    x1: 8.5332,
    y1: 13.7912,
    x2: 36.5049,
    y2: 33.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC261"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8143_15485",
    x1: 0.69421,
    y1: 14.6826,
    x2: 46.5552,
    y2: 47.1881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8143_15485",
    x1: 13.4745,
    y1: 25.7899,
    x2: 38.3621,
    y2: 28.7754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8143_15485",
    x1: 11.4374,
    y1: 23.114,
    x2: 21.5921,
    y2: 26.5498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidIdVerificationIcon);
export default __webpack_public_path__ + "static/media/bfid-id-verification-icon.9ceae613b156ebacccd7fa21eec6ae44.svg";
export { ForwardRef as ReactComponent };